import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FeedbackAthleteAnswerProvider } from '../../providers/feedback-athlete-answer-provider';
import { Subscription } from 'rxjs';
import { Organization } from "../../../common/models/organization";
import { Athlete } from "../../../common/models/athlete";
import { FeedbackAthleteAnswer } from "../../../common/models/feedback-athlete-answer";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { NgIf } from "@angular/common";

@Component({
  selector: 'app-feedback-athlete-smiley',
  styleUrls: ['./feedback-athlete-smiley.component.scss'],
  templateUrl: './feedback-athlete-smiley.component.html',
  imports: [
    MatProgressSpinner,
    NgIf
  ],
  standalone: true
})
export class FeedbackAthleteSmileyComponent implements OnInit, OnDestroy {

  public isLoading = true;

  @Input()
  public mood: string | null = null

  @Input()
  public organization: Organization = {} as Organization;

  @Input()
  public athlete: Athlete = {} as Athlete;

  @Input()
  public defaultClass = 'athlete-smiley-icon material-icons';

  private subscriptions: Subscription[] = [];

  constructor(
    private feedbackAthleteAnswerProvider: FeedbackAthleteAnswerProvider
  ) {
  }

  public ngOnInit(): void {
    this.mood = this.athlete?.lastMood ?? null;
    // TODO : Remove this in future when confirmed that the athlete.lastMood is always set
    // if (this.mood === null) {
    //       this.subscriptions.push(
    //           this.feedbackAthleteAnswerProvider.findLatestFeedbackMood(this.organization, this.athlete).subscribe((data:any) => {
    //               this.mood = data['mood'];
    //               this.isLoading = false;
    //           })
    //       );
    //   } else {
    //       this.isLoading = false;
    //   }
    this.isLoading = false;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  public evaluateIcon(): string {
    if (this.mood === FeedbackAthleteAnswer.MOOD_WELL) {
      return 'sentiment_very_satisfied';
    }

    if (this.mood === FeedbackAthleteAnswer.MOOD_NOT_WELL) {
      return 'sentiment_very_dissatisfied';
    }

    return 'sentiment_satisfied';
  }
}
